import React, { useEffect, useState } from "react";
import { useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import * as Linking from 'expo-linking';
import Button from "theme/Button";
import _ from "lodash";
import { PlaceholderBooking } from "placeholders";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedBlock from "components/atoms/ThemedBlock";
import { View } from "react-native";
import { ThemedSizes, ThemedValues } from "styles/themed";
import HelperSetting from "utils/helper-setting";
import { settingsConstants } from "utils/constants/settings-constants";
import EmployeeCard, { EmployeeCardModes, EmployeeCardShowConfidant } from "components/molecules/EmployeeCard";
import { useSelector } from 'react-redux'
import selectEmployeeConfidants from 'services/redux/data/selectors/selectEmployeeConfidants'
import { openUrl } from 'utils/helper-url'
import HelperDate from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'

const HomeCoworkerViewConfidantScene = () => {

	const route = useRoute();

	const _employeeConfidants = useSelector( selectEmployeeConfidants )

	const [ loading, setLoading ] = useState( true )
	const [ refreshing, setRefreshing ]= useState( false )
	const [ employee, setEmployee] = useState( null )

	const getLinkingTel = () => {
		return `tel:${employee.phonenumber}`;
	}

	const onPressCall = () => {
		const url = getLinkingTel();

		if( Linking.canOpenURL( url ) ) {
			openUrl( url );
		}
	}

	const getLinkingEmergency = () => {
		return `tel:${HelperSetting.get( settingsConstants.EMERGENCY_NUMBER ) }`;
	}

	const onPressEmergencyCall = () => {
		const url = getLinkingEmergency();

		if( Linking.canOpenURL( url ) ) {
			openUrl( url );
		}
	}

	// On start
	useEffect(() => {
		const routeEmployee = _.get( route, ['params', 'employee'], {} );
		const employee = _.find( _employeeConfidants, { guid: routeEmployee } );

		setEmployee( employee );
		setLoading( false );
	}, [ _employeeConfidants ]);

	return (
		<ThemedSafeAreaComponentTop
			top={false}>

			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				title={ i18n.t('page.confidant.title') }
				subtitle={ _.get( employee, 'name', '?') }>

				<Choose>
					<When condition={ loading && !refreshing }>
						<PlaceholderBooking />
					</When>
					<Otherwise>
						<VStack space={ ThemedValues.stackSpace }>
							<ThemedBlock
								smallPadding
								shadow>
	
								<EmployeeCard
									mode={ EmployeeCardModes.listItem }
									employee={ employee }
									avatarSize={ ThemedSizes.M }
									avatarShowIconEro={ true }
									avatarShowIconConfidant={ true }
									show={ EmployeeCardShowConfidant }
									showDetails={ true }
									selectedLocationDate={ HelperDate.date() }
								/>
							</ThemedBlock>
							
							<ThemedBlock
								smallPadding
								shadow>
								<View>
									<Button onPress={ onPressCall }>
										{ i18n.t('page.confidant.button_call', {name: employee?.name }) }
									</Button>
								</View>
							</ThemedBlock>
						</VStack>
					</Otherwise>
				</Choose>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeCoworkerViewConfidantScene
